<template>
<div class="page-container">
  <div class="card-title" v-show="showSearch">
    <el-form size="small" label-width="68px" :model="queryParams" ref="queryForm">
      <el-row :gutter="48">
        <el-col :md="6" :sm="24">
          <el-form-item :label="$t('字典名称')">
            <el-input v-model="queryParams.dictName" class="search-item" :placeholder="$t('请输入字典名称')" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="6" :sm="24">
          <el-form-item :label="$t('字典类型')">
            <el-input v-model="queryParams.dictType" class="search-item" :placeholder="$t('请输入字典类型')" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="6" :sm="24">
          <el-form-item :label="$t('字典状态')">
            <el-select v-model="queryParams.status" class="search-item" :placeholder="$t('请选择字典状态')" clearable>
              <el-option
                v-for="dict in dict.type.sys_active_state"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="6" :sm="24" v-if="advanced">
          <!-- 创建时间 -->
          <el-form-item :label="$t('创建时间')">
            <el-date-picker
              v-model="queryParams.dataRange"
              class="search-item"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="-"
:start-placeholder="$t('开始日期')"
:end-placeholder="$t('结束日期')"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <div class="search-content">
          <!-- 搜索按钮 -->
          <el-form-item class="search-button">
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">{{ $t('搜索') }}</el-button>
            <el-button icon="el-icon-refresh" size="mini" @click="handleReset">{{ $t('重置') }}</el-button>
            <el-button
              type="text"
              :icon="advanced ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
              class="advanced-button"
              @click="toggleAdvanced">
              {{ advanced ? $t('关闭') : $t('展开') }}
            </el-button>
          </el-form-item>
        </div>
      </el-row>
    </el-form>
  </div>
  <div class="card">
    <el-row :gutter="10" class="button-container">
      <el-col :span="1.5">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd" size="mini" plain>
          {{ $t('新增') }}
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="success" icon="el-icon-edit" size="mini" plain :disabled="single" @click="handleUpdate">{{ $t('编辑') }}</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="danger" icon="el-icon-delete" size="mini" plain :disabled="multiple" @click="handleDelete" :loading="buttonLoading">{{ $t('删除') }}</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="info" icon="el-icon-refresh" size="mini" plain :loading="buttonLoading" @click="refreshDictCache">{{ $t('刷新缓存') }}</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" :columns="columns" @getTableData="getTableData"></right-toolbar>
    </el-row>

    <el-table v-loading="loading" :element-loading-text="$t('正在加载表格数据')" :data="tableData" @selection-change="handleSelectionChange" border>
      <template slot="empty">
        <el-empty :image-size="200"></el-empty>
      </template>
      <el-table-column type="selection" width="50" align="center" />
      <!-- 字典名称 -->
      <el-table-column prop="dictName" :label="$t('字典名称')" align="center" v-if="columns[0].visible"></el-table-column>
      <!-- 字典类型 -->
      <el-table-column prop="dictType" :label="$t('字典类型')" align="center" v-if="columns[1].visible">
        <template slot-scope="scope">
          <router-link :to="'/system-content/dict-data/' + scope.row.id" class="link-type">
            {{ scope.row.dictType }}
          </router-link>
        </template>
      </el-table-column>
      <!-- 字典状态 -->
      <el-table-column prop="status" :label="$t('字典状态')" align="center" v-if="columns[2].visible">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status" type="primary" size="small">{{ $t('正常') }}</el-tag>
          <el-tag v-else type="danger" size="small">{{ $t('停用') }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" :label="$t('创建时间')" align="center" v-if="columns[3].visible">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | dateFilter }}</span>
        </template>
      </el-table-column>
      <!-- 备注 -->
      <el-table-column prop="remark" :label="$t('备注')" align="center" v-if="columns[4].visible" show-overflow-tooltip></el-table-column>
      <el-table-column :label="$t('操作')"  align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" icon="el-icon-view" @click="gotoDictData(scope.row.id)">{{ $t('查看') }}</el-button>
          <el-button type="text" size="small" icon="el-icon-edit" @click="handleUpdate(scope.row)">{{ $t('编辑') }}</el-button>
          <el-button type="text" size="small" icon="el-icon-delete" @click="handleDelete(scope.row)">{{ $t('删除') }}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页器 -->
    <pagination
      :background="false"
      :total="total"
      :page.sync="queryParams.currentPage"
      :limit.sync="queryParams.pageSize"
      @pagination="getTableData"
    />
  </div>

  <!-- 字典类型信息对话框 -->
  <el-dialog
    :title="dictTypeTitle"
    width="500px"
    :modal-append-to-body="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :visible="dictTypeVisible"
    :before-close="handleClose">
    <div class="dictType-wrapper" v-loading="dictTypeLoading" :element-loading-text="$t('正在加载字典类型信息')">
      <el-form ref="dictTypeForm" :model="formData" :rules="rules" label-width="80px" label-position="right">
        <el-row :gutter="15">
          <!-- 字典名称 -->
          <el-form-item :label="$t('字典名称')" prop="dictName">
            <el-input v-model="formData.dictName" :placeholder="$t('请输入字典名称')" clearable></el-input>
          </el-form-item>
          <!-- 字典类型 -->
          <el-form-item :label="$t('字典类型')" prop="dictType">
            <el-input v-model="formData.dictType" :placeholder="$t('请输入字典类型')" clearable></el-input>
          </el-form-item>
          <!-- 字典状态 -->
          <el-form-item :label="$t('字典状态')" prop="status">
            <el-radio-group v-model="formData.status">
              <el-radio :label="true">{{ $t('正常') }}</el-radio>
              <el-radio :label="false">{{ $t('停用') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 备注 -->
          <el-form-item :label="$t('备注')" prop="remark">
            <el-input type="textarea" v-model="formData.remark" :placeholder="$t('请输入备注')" clearable></el-input>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button
        type="danger"
        :loading="buttonLoading"
        @click="handleClose()"
        size="small"
        icon="el-icon-error">
        {{ $t('取消') }}
      </el-button>
      <el-button
        type="success"
        :loading="buttonLoading"
        @click="submitForm()"
        size="small"
        icon="el-icon-success">
        {{ $t('保存') }}
      </el-button>
    </div>
  </el-dialog>
</div>
</template>
<script>
import { translateUi } from '../../../i18n'
import Pagination from '../../../components/Pagination/index'
import RightToolbar from '../../../components/RightToolbar/index'
import { listDictTypes, saveDictType, getDictTypeById, deleteDictType, refresh } from '../../../api/system/dict-type'

export default {
  name: 'DictType',

  dicts: ['sys_active_state'],

  components: { Pagination, RightToolbar },

  data () {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      // 是否展示搜索内容
      showSearch: true,
      // 数据总条数
      total: 0,
      // 字典类型对话框是否显示
      dictTypeVisible: false,
      // 数据表格等待框
      loading: false,
      // 查询参数
      queryParams: {
        // 页数
        currentPage: 1,
        // 页面大小
        pageSize: 20,
        // 字典名称
        dictName: undefined,
        // 字典类型
        dictType: undefined,
        // 字典状态
        status: undefined,
        // 时间范围
        dataRange: []
      },
      // 字典类型表单对象
      formData: {
        // 字典名称
        dictName: undefined,
        // 字典类型
        dictType: undefined,
        // 备注
        remark: undefined,
        // 字典状态
        status: true
      },
      // 字典类型表单校验规则
      rules: {
        // 字典名称
        dictName: [{ required: true, get message () { return translateUi('请输入字典名称') }, trigger: 'blur' }],
        // 字典类型
        dictType: [{ required: true, get message () { return translateUi('请输入字典类型') }, trigger: 'blur' }],
        // 字典状态
        status: [{ required: true, get message () { return translateUi('请选择字典状态') }, trigger: 'blur' }]
      },
      // 字典类型对话框等待框
      dictTypeLoading: false,
      // 对话框按钮等待框
      buttonLoading: false,
      // 列信息
      columns: [
        // 字典名称
        { key: 0, get label () { return translateUi('字典名称') }, visible: true },
        // 字典类型
        { key: 1, get label () { return translateUi('字典类型') }, visible: true },
        // 字典状态
        { key: 2, get label () { return translateUi('字典状态') }, visible: true },
        { key: 3, get label () { return translateUi('创建时间') }, visible: true },
        // 备注
        { key: 4, get label () { return translateUi('备注') }, visible: true }
      ],
      // 表格数据
      tableData: [],
      // 表头选中的数据
      ids: [],
      // 多数据禁用
      single: true,
      // 单数据禁用
      multiple: true,
      // 对话框标题
      dictTypeTitle: ''
    }
  },

  mounted () {
    this.$nextTick(() => {
      // 赋值当前页面内容
      this.title = this.$route.meta.title
      // 查询表格数据
      this.getTableData()
    })
  },

  methods: {
    // 获取表格数据
    getTableData () {
      // 开启加载框
      this.loading = true
      listDictTypes(this.queryParams).then((res) => {
        // 赋值数据参数
        this.tableData = res.list
        this.total = res.total
        // 关闭等待框
        this.loading = false
      }).catch(() => {
        // 确保加载框可以关闭
        this.loading = false
      })
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 点击查询按钮
    handleQuery () {
      this.queryParams.currentPage = 1
      this.getTableData()
    },
    // 点击重置按钮
    handleReset () {
      // 字典名称
      this.queryParams.dictName = undefined
      // 字典类型
      this.queryParams.dictType = undefined
      // 字典状态
      this.queryParams.status = undefined
      this.queryParams.dataRange = []
    },
    // 打开字典类型信息对话框
    handleOpen () {
      // 清除表单数据
      this.reset()
      this.dictTypeVisible = true
    },
    // 关闭字典类型对话框表单
    handleClose () {
      this.reset()
      this.dictTypeVisible = false
    },
    // 点击新增按钮
    handleAdd () {
      this.$setUiText('dictTypeTitle', '新增字典类型')
      this.handleOpen()
    },
    // 点击编辑按钮
    handleUpdate (row) {
      // 修改对话框标题
      this.$setUiText('dictTypeTitle', '更新字典类型')
      // 获取到传来的ID
      const dictTypeId = row.id || this.ids
      // 打开加载框
      this.dictTypeLoading = true
      // 根据字典类型ID获取对应的数据
      getDictTypeById(dictTypeId).then((res) => {
        // 赋值当前的字典类型数据
        this.formData = res
        // 打开编辑字典类型对话框
        this.dictTypeVisible = true
        // 关闭加载框
        this.dictTypeLoading = false
      }).catch(() => {
        // 关闭加载框
        this.dictTypeLoading = false
      })
    },
    // 点击删除事件
    handleDelete (row) {
      const that = this
      let dictTypeIds = []
      if (row.id) {
        dictTypeIds.push(row.id)
      } else {
        dictTypeIds = this.ids
      }
      this.$confirm(translateUi('是否确认删除选中的字典类型数据？'), translateUi('提示'), {
        confirmButtonText: translateUi('确定'),
        cancelButtonText: translateUi('取消'),
        type: 'warning'
      }).then(() => {
        that.buttonLoading = true
        that.loading = true
        deleteDictType(dictTypeIds).then((res) => {
          that.buttonLoading = false
          that.$message.success(translateUi('删除成功'))
          // 刷新数据
          that.getTableData()
        }).catch(() => {
          // 确保加载框会关闭
          that.buttonLoading = false
          that.loading = false
        })
      }).catch(() => {})
    },
    // 提交表单
    submitForm () {
      const that = this
      this.$refs.dictTypeForm.validate(valid => {
        // 校验未通过则直接返回
        if (!valid) return
        // 开启加载框
        that.buttonLoading = true
        that.dictTypeLoading = true
        // 提交表单
        saveDictType(that.formData).then((res) => {
          // 根据是否存在ID输出对应消息
          if (that.formData.id) {
            // 输出更新成功信息
            that.$message.success(translateUi('字典类型信息更新成功'))
          } else {
            // 输出添加成功消息
            that.$message.success(translateUi('字典类型添加成功'))
          }
          // 刷新表单数据并关闭对话框
          that.handleClose()
          // 刷新字典类型数据
          that.getTableData()
          // 关闭加载框
          that.buttonLoading = false
          that.dictTypeLoading = false
        }).catch(() => {
          // 关闭加载框
          that.buttonLoading = false
          that.dictTypeLoading = false
        })
      })
    },
    // 刷新缓存
    refreshDictCache () {
      const that = this
      that.buttonLoading = true
      refresh().then(() => {
        // 清空vuex中的字典数据
        this.$store.dispatch('dict/cleanDictData')
        this.$message.success(translateUi('字典缓存刷新成功'))
        that.buttonLoading = false
      }).catch(() => {
        that.buttonLoading = false
      })
    },
    // 重置表单
    reset () {
      // 清除校验条件
      this.formData = {
        // 字典类型ID
        id: undefined,
        // 字典名称
        dictName: undefined,
        // 字典类型
        dictType: undefined,
        // 字典状态
        status: true
      }
      // 清除表单校验
      this.resetForm('dictTypeForm')
    },
    // 多选框
    handleSelectionChange (selection) {
      // 获取当前选中数组的ID
      this.ids = selection.map(item => item.id)
      // 表头的编辑是否可以点击
      this.single = selection.length !== 1
      // 表头的删除是否可以点击
      this.multiple = !selection.length
    },
    // 跳转到对应字典类型页面
    gotoDictData (dictTypeId) {
      this.$router.push('/system-content/dict-data/' + dictTypeId)
    }
  }
}

</script>

<style lang="scss" scoped>
.dictType-wrapper {
  padding: 10px 30px;
}
</style>
